import { Layout, Row, Col } from "antd";
import logo_dark from "../img/logo_dark.png";
import { FacebookFilled, InstagramFilled } from "@ant-design/icons";
import "./Footer.css";

const { Footer } = Layout;

const AppFooter = () => {
  return (
    <Footer className="custom-footer">
      <Row gutter={0} align="middle" justify="center">
        <Col xs={24} md={7} className="footer-logo">
          <div className="footer-left-align">
            <img src={logo_dark} alt="Logo" className="footer-logo" />
          </div>
        </Col>

        <Col xs={24} md={10}>
          <div className="footer-center-align">
            <h3>Ukratko</h3>
            <p>Psihološko savjetovalište namijenjeno za sve studente Univerziteta u Banjoj Luci</p>
            <p><strong>Email:</strong> psiholoskosavjetovaliste@ff.unibl.org</p>
            <p><strong>Telefon:</strong> 065/464-555</p>
            <p><strong>Adresa:</strong> Bulevar vojvode Petra Bojovića 1A, Filozofski fakultet, 78000 Banja Luka</p>
          </div>
        </Col>

        <Col xs={24} md={7} className="footer-right-align-column">
          <div className="footer-right-align">
            <p className="social-p">Više informacija o nama, našim aktivnostima, kao i načinu prijave možete pronaći na našim društvenim mrežama.</p>
            <div className="social-icons">
              <a href="https://www.facebook.com/PsiholoskoSavjetovalisteZaStudenteUNIBL/?locale=sr_RS" target="_blank" rel="noreferrer">
                <FacebookFilled />
              </a>
              <a href="https://www.instagram.com/psiholosko_savjetovalisteunibl/" target="_blank" rel="noreferrer">
                <InstagramFilled />
              </a>
            </div>
          </div>
        </Col>
      </Row>
      <div className="footer-bottom-text">
        &copy; {new Date().getFullYear()} Psihološko Savjetovalište UNIBL. Sva prava zadržana.
      </div>
    </Footer>
  );
};

export default AppFooter;